import { useMutation, useQueryClient } from '@tanstack/react-query';
import { map, uniq } from 'lodash/fp';
import { useDispatch } from 'react-redux';

import { toastrError, toastrSuccess } from '@portals/redux/actions/toastr';
import { CommandType } from '@portals/types';

import { COMMANDS_API_URL } from './commands.constants';
import { SendCommandParams } from './commands.types';
import { MutationOptions } from '../../types';
import { fetchApiRequest, useRequestOptions } from '../../utils';
import { devicesQueryKeys } from '../devices';

export function useSendCommand(
  mutationOptions: MutationOptions<
    Array<CommandType>,
    { error: string },
    SendCommandParams
  > = {}
) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { url, options } = useRequestOptions({
    url: COMMANDS_API_URL,
    method: 'POST',
  });

  return useMutation({
    mutationFn: (commandParams): Promise<Array<CommandType>> =>
      fetchApiRequest(url, {
        ...options,
        body: JSON.stringify({
          ...commandParams,
          command: commandParams.command.name,
        }),
      }),
    onSuccess: (commands) => {
      const queriesToInvalidate = map(
        (command) => uniq(devicesQueryKeys.commands.all(command.device_id)),
        commands
      );

      queryClient.invalidateQueries(...queriesToInvalidate);

      dispatch(toastrSuccess('Command successfully sent'));
    },
    onError: ({ error }: any) => {
      dispatch(toastrError(error));
    },
    ...mutationOptions,
  });
}
